// extracted by mini-css-extract-plugin
export var closeContainer = "ModalProvider-module--closeContainer--5c7a2";
export var modalContainer = "ModalProvider-module--modalContainer--637b5";
export var modalContent = "ModalProvider-module--modalContent--e4254";